module.exports = __webpack_public_path__ + "static/media/05Demo Photo-ink.7ff194a1.jpeg";